<template>
  <div v-loading="loading">
    <div v-if="form" class="internal-form">
      <el-form
        ref="form"
        label-position="top"
        label-width="220px"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="Слаг" prop="slug">
          <el-input v-model="form.slug" />
          <div v-if="form.slug" class="slug-preview">URL страницы: {{ generateSlugPreview }}</div>
          {{ $_ErrorMixin_getError('slug') }}
        </el-form-item>

        <el-form-item label="Заголовок страницы UA" prop="title">
          <el-input v-model="form.title" />
          {{ $_ErrorMixin_getError('title') }}
        </el-form-item>
        <el-form-item label="Заголовок страницы RU" prop="title_ru">
          <el-input v-model="form.title_ru" />
          {{ $_ErrorMixin_getError('title_ru') }}
        </el-form-item>

        <el-form-item label="Описание страницы UA" prop="description">
          <el-input v-model="form.description" type="textarea" />
          {{ $_ErrorMixin_getError('description') }}
        </el-form-item>
        <el-form-item label="Описание страницы RU" prop="description_ru">
          <el-input v-model="form.description_ru" type="textarea" />
          {{ $_ErrorMixin_getError('description_ru') }}
        </el-form-item>

        <div class="inline-form-container">
          <el-form-item label="Заглавное изображение страницы" prop="image">
            <SingleImageEdit
              :image-preview="imagePreview"
              @status-change="addImage"
            />
            <div v-if="imageError">
              {{ $_ErrorMixin_getError('file') }}
            </div>
          </el-form-item>
        </div>
        <el-form-item label="Название CTA кнопки UA" prop="button_name">
          <el-input v-model="form.button_name" />
          {{ $_ErrorMixin_getError('button_name') }}
        </el-form-item>
        <el-form-item label="Название CTA кнопки RU" prop="button_name_ru">
          <el-input v-model="form.button_name_ru" />
          {{ $_ErrorMixin_getError('button_name_ru') }}
        </el-form-item>

        <el-form-item label="Ccылка для CTA кнопки UA" prop="button_link">
          <el-input v-model="form.button_link" />
          {{ $_ErrorMixin_getError('button_link') }}
        </el-form-item>
        <el-form-item label="Ссылка для CTA кнопки RU" prop="button_link_ru">
          <el-input v-model="form.button_link_ru" />
          {{ $_ErrorMixin_getError('button_link_ru') }}
        </el-form-item>

        <el-form-item class="categories-form-item" label="Категории" prop="categoriesIds">
          <div
            v-if="form.categoriesIds && form.categoriesIds.length > 0"
            class="draggable-chips-container"
          >
            <div @click="openCategoriesDropdown">
              <draggable
                v-model="draggableCategories"
                class="draggable-chips"
                @end="onDragEnd"
              >
                <div
                  v-for="categoryId in draggableCategories"
                  :key="categoryId"
                  class="draggable-chip"
                >
                  <i class="el-icon-rank drag-handle" />
                  <span class="chip-label">{{ getCategoryName(categoryId) }}</span>
                  <i
                    class="el-icon-close chip-close"
                    @click.stop="removeCategory(categoryId)"
                  />
                </div>
              </draggable>
            </div>
          </div>

          <el-select
            ref="categoriesSelect"
            v-model="form.categoriesIds"
            class="category-multiselect"
            multiple
            placeholder="Выберите категории"
            style="width: 100%"
            value-key="id"
            @change="onCategoriesChange"
          >
            <el-option-group
              v-for="group in categories"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="category in group.children"
                :key="category.id"
                :label="category.name"
                :value="category.id"
              />
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item label="SEO Title UA" prop="seo_title">
          <el-input v-model="form.seo_title" />
          {{ $_ErrorMixin_getError('seo_title') }}
        </el-form-item>
        <el-form-item label="SEO Title RU" prop="seo_title_ru">
          <el-input v-model="form.seo_title_ru" />
          {{ $_ErrorMixin_getError('seo_title_ru') }}
        </el-form-item>

        <el-form-item label="SEO Description UA" prop="seo_description">
          <el-input v-model="form.seo_description" />
          {{ $_ErrorMixin_getError('seo_description') }}
        </el-form-item>

        <el-form-item label="SEO Description RU" prop="seo_description_ru">
          <el-input v-model="form.seo_description_ru" />
          {{ $_ErrorMixin_getError('seo_description_ru') }}
        </el-form-item>

        <el-form-item label="SEO ключевая фраза UA" prop="seo_key_phrase">
          <el-input v-model="form.seo_key_phrase" />
          {{ $_ErrorMixin_getError('seo_key_phrase') }}
        </el-form-item>
        <el-form-item label="SEO ключевая фраза RU" prop="seo_key_phrase_ru">
          <el-input v-model="form.seo_key_phrase_ru" />
          {{ $_ErrorMixin_getError('seo_key_phrase_ru') }}
        </el-form-item>

        <el-form-item label="SEO Текст UA" prop="seo_text">
          <el-input v-model="form.seo_text" type="textarea" />
          {{ $_ErrorMixin_getError('seo_text') }}
        </el-form-item>

        <el-form-item label="SEO Текст RU" prop="seo_text_ru">
          <el-input v-model="form.seo_text_ru" type="textarea" />
          {{ $_ErrorMixin_getError('seo_text_ru') }}
        </el-form-item>

        <el-form-item label="Cтатус" prop="state">
          <el-select
            v-model="selectedState"
            placeholder="Select"
          >
            <el-option
              v-for="state in states"
              :key="state.value"
              :label="state.label"
              :value="state.value"
            />
          </el-select>
          {{ $_ErrorMixin_getError('state') }}
        </el-form-item>

        <el-form-item label="Порядок вывода" prop="position">
          <el-input v-model="form.position" type="number" />
          {{ $_ErrorMixin_getError('position') }}
        </el-form-item>
      </el-form>
      <el-button type="success" @click="save">
        <span v-if="id">Сохранить</span>
        <span v-else>Создать</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import ErrorMixin from '@/utils/ErrorMixin';
import SingleImageEdit from '../common/SingleImageEdit.vue';
import draggable from 'vuedraggable';

let defaultValues = {
  slug: '',
  title: '',
  title_ru: '',
  description: '',
  description_ru: '',
  button_name: '',
  button_name_ru: '',
  button_link: '',
  button_link_ru: '',
  seo_text: '',
  seo_text_ru: '',
  position: 1,
  categoriesIds: [],
  seo_title: '',
  seo_title_ru: '',
  seo_description: '',
  seo_description_ru: '',
  seo_key_phrase: '',
  seo_key_phrase_ru: '',
  state: '',
  image: null,
};

export default {
  name: 'TopicForm',
  components: {SingleImageEdit, draggable},
  mixins: [ErrorMixin],
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageError: false,
      formTitle: null,
      formData: new FormData(),
      form: {},
      selectedCityId: null,
      selectedImage: null,
      imagePreview: null,
      selectedState: 'DRAFT',
      loading: false,
      draggableCategories: [],
      states: [
        {value: 'PUBLISHED', label:'PUBLISHED'},
        {value: 'DRAFT', label:'DRAFT'}],
      filterObject: {
        page: 1,
        search: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)).getTime();
        },
      },
        rules: {
          slug: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (/\s/.test(value)) {
                  callback(new Error('Slug не должен содержать пробелы'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],

          title: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 100, message: 'Заголовок UA должен быть от 3 до 100 символов', trigger: 'blur' },
          ],
          title_ru: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 100, message: 'Заголовок RU должен быть от 3 до 100 символов', trigger: 'blur' },
          ],

          description: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 180, message: 'Описание UA должно быть от 3 до 180 символов', trigger: 'blur' },
          ],
          description_ru: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 180, message: 'Описание RU должно быть от 3 до 8000 180', trigger: 'blur' },
          ],

          button_name: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 25, message: 'Название кнопки UA должно быть от 3 до 25 символов', trigger: 'blur' },
          ],
          button_name_ru: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 25, message: 'Название кнопки RU должно быть от 3 до 25 символов', trigger: 'blur' },
          ],
          button_link: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 255, message: 'Ссылка UA должна быть от 3 до 255 символов', trigger: 'blur' },
            { type: 'url', message: 'Это поле должно быть ссылкой', trigger: 'blur' },
          ],
          button_link_ru: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
            { min: 3, max: 255, message: 'Ссылка UA должна быть от 3 до 255 символов', trigger: 'blur' },
            { type: 'url', message: 'Это поле должно быть ссылкой', trigger: 'blur' },
          ],

          seo_text: [{ max: 10000, message: 'SEO Text UA должно быть до 10000 символов', trigger: 'blur' }],
          seo_text_ru: [{ max: 10000, message: 'SEO Text RU должно быть до 10000 символов', trigger: 'blur' }],

          seo_title: [{ max: 255, message: 'SEO Title UA должен быть до 255 символов', trigger: 'blur' }],
          seo_title_ru: [{ max: 255, message: 'SEO Title RU должен быть до 255 символов', trigger: 'blur' }],

          seo_description: [{ max: 255, message: 'SEO Description UA должен быть до 255 символов', trigger: 'blur' }],
          seo_description_ru: [{ max: 255, message: 'SEO Description RU должен быть до 255 символов', trigger: 'blur' }],

          seo_key_phrase: [{ max: 255, message: 'SEO ключевая фраза UA должен быть до 255 символов', trigger: 'blur' }],
          seo_key_phrase_ru: [{ max: 255, message: 'SEO ключевая фраза RU должен быть до 255 символов', trigger: 'blur' }],

          position: [
            { required: true, message: 'Обязательное поле', trigger: 'blur' },
          ],

          categoriesIds: [
            { required: true, message: 'Обязательное поле', trigger: ['blur', 'change']  },
            { type: 'array', message: 'Категории должны быть массивом', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value.length === 0) {
                  callback(new Error('Нужно выбрать хотя бы одну категорию'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
      },
    }
  },
  computed: {
    ...mapState('wishes/categories', [
      'categories',
    ]),
    generateSlugPreview() {
      if (this.form.slug) {
        return `egolist.ua/topic-${this.form.slug}`;
      } else {
        return '';
      }
    },
  },
  watch: {
    'form.categoriesIds': {
      handler(newCategories) {
        this.draggableCategories = [...newCategories];
      },
      immediate: true,
    },
  },
  async created() {
    this.loading = true
    await this.fetchCategories()
    this.loading = false
    if (this.id) {
      this.loading = true
      try {
        await this.getTopicForEdit()
      } finally {
        this.loading = false
      }
    } else {
      this.form = {...defaultValues}
    }
  },
  methods:{
    ...mapActions('topics', [
      'createTopic', 'getTopicById', 'editTopic',
    ]),
    ...mapActions('cities', [
      'fetchCities','preloadCities',
    ]),
    ...mapActions('wishes/categories', ['fetchCategories']),

    addImage(image) {
      if (!image) return
      this.formData.append('image', image, image?.name);
    },

    onCategoriesChange() {
      this.draggableCategories = [...this.form.categoriesIds];
    },

    onDragEnd() {
      this.form.categoriesIds = [...this.draggableCategories];
    },

    removeCategory(categoryId) {
      const index = this.form.categoriesIds.indexOf(categoryId);
      if (index > -1) {
        this.form.categoriesIds.splice(index, 1);
        this.draggableCategories = [...this.form.categoriesIds];
      }
    },

    getCategoryName(categoryId) {
      for (const group of this.categories) {
        for (const category of group.children) {
          if (category.id === categoryId) {
            return category.name;
          }
        }
      }
      return 'Unknown Category';
    },

    async getTopicForEdit () {
      const data = await this.getTopicById(this.id);
      const topic = data.data;

      this.form = {
        id: topic.id,
        slug: topic.slug,
        title: topic.title,
        title_ru: topic.title_ru,
        description: topic.description,
        description_ru: topic.description_ru,
        button_name: topic.button_name,
        button_name_ru: topic.button_name_ru,
        button_link: topic.button_link,
        button_link_ru: topic.button_link_ru,
        seo_text: topic.seo_text || '',
        seo_text_ru: topic.seo_text_ru || '',
        position: topic.position,
        categoriesIds: topic.categories.map(category => category.id),
        seo_title: topic.seo_title || '',
        seo_title_ru: topic.seo_title_ru || '',
        seo_description: topic.seo_description || '',
        seo_description_ru: topic.seo_description_ru || '',
        seo_key_phrase: topic.seo_key_phrase|| '',
        seo_key_phrase_ru: topic.seo_key_phrase_ru|| '',
        state: topic.state,
        image: topic.image,
      };

      this.selectedState = topic.state;

      this.selectedImage = topic.image;
      this.imagePreview = topic.image;
    },
    async save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            // Reset FormData to avoid duplicate entries
            //this.formData = new FormData()

            this.form.state = this.selectedState

            for (const key in this.form) {
              if (key === 'categoriesIds' && Array.isArray(this.form[key])) {
                this.form[key].forEach((categoryId, index) => {
                  this.formData.append(`categoriesIds[${index}]`, categoryId)
                })
              } else {
                this.formData.append(key, this.form[key])
              }
            }

            if (this.id) {
              await this.editTopic({formData: this.formData, id: this.form.id})
              this.$message.success('Топик успешно обновлен')
            } else {
              await this.createTopic({formData: this.formData})
              this.$message.success('Топик успешно создан')
            }

            this.$_ErrorMixin_clearErrors()
            this.$router.push({ name: 'TopicsListPage' })
          } catch (error) {
            this.$_ErrorMixin_handleError(error)
          }
        }
      })
    },
    resetDefaultValues() {
      this.form = { ...defaultValues };
      this.selectedImage = null;
      this.imagePreview = null;
      this.selectedState = 'DRAFT';
    },
    openCategoriesDropdown() {
      // Focus on the select element to trigger the dropdown
      this.$refs.categoriesSelect.focus();
      // Trigger a click event to open the dropdown
      this.$refs.categoriesSelect.$el.click();
    },
  },
}
</script>

<style lang="sass" scoped>
.slug-preview
  margin-top: 5px
  font-style: italic
  color: #888

.inline-form-container
  display: flex

.draggable-chips-container
  margin-bottom: 0

.draggable-chips-label
  font-size: 14px
  color: #606266
  font-weight: 500

.draggable-chips
  display: flex
  flex-wrap: wrap
  gap: 8px
  min-height: 32px
  padding: 4px
  border: 1px solid #dcdfe6
  border-radius: 4px
  background-color: #fff
  cursor: pointer
  transition: all 0.2s ease

  &:hover
    border-color: #409eff
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2)

.draggable-chip
  display: flex
  align-items: center
  gap: 6px
  padding: 4px 8px
  background-color: #f0f9ff
  border: 1px solid #409eff
  border-radius: 4px
  font-size: 12px
  color: #409eff
  cursor: move
  user-select: none
  transition: all 0.2s ease

  &:hover
    background-color: #e6f7ff
    border-color: #66b1ff

  &.sortable-ghost
    opacity: 0.5
    background-color: #e6f7ff

  &.sortable-chosen
    background-color: #d9f2ff
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3)

.drag-handle
  font-size: 14px
  color: #909399
  cursor: move

.chip-label
  flex: 1
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  max-width: 150px

.chip-close
  font-size: 12px
  color: #909399
  cursor: pointer
  padding: 2px
  border-radius: 2px
  transition: all 0.2s ease

  &:hover
    color: #f56c6c
    background-color: #fef0f0

.category-multiselect
  height: 0
  overflow: hidden
  position: relative
  top: -60px

.categories-form-item
  margin-bottom: -20px
</style>
